var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar',{staticStyle:{"border-bottom-style":"solid","border-width":"1px","border-color":"lightgrey !important"},attrs:{"flat":"","color":"white darken-4","light":""}},[_c('v-toolbar-title',{staticClass:"text-xs-center"},[_vm._v("Verified applications")]),_vm._v(" "),_c('v-spacer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61950b83","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/applications/Verifiedapplicationstitle.vue
// module id = null
// module chunks = 